// @flow
import React, {type Node, Fragment} from 'react'
import {type RelayFragmentContainer, createFragmentContainer, graphql} from 'react-relay'

import uniqueArrayById from 'utils/MiscUtils/uniqueArrayById'
import liftNodes from 'utils/GraphQL/typedLiftNodes'
import sortByProp from 'utils/MiscUtils/sortByProp'
import ItemsSection from 'components/SideBar/ui/ItemsSection'
import CircleAssignments from './CircleAssignments'
import type {
  YourRolesSection_organization as Organization,
} from './__generated__/YourRolesSection_organization.graphql'

type Props = $ReadOnly<{
  organization: Organization,
}>

const sortByNameCaseInsensitive = sortByProp('localizedName')

function YourRolesSection({organization}: Props): Node {
  const assignments = liftNodes(organization.viewer.assignments)
  const circles = assignments.map((assignment) => assignment.role.circle).filter(Boolean)
  const uniqueCircles = uniqueArrayById(circles)
  const circleAssignments = (circle) => (
    assignments.filter((assignment) => assignment.role.circle?.id === circle.id)
  )

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <Fragment>
      <ItemsSection
        collapsibleSection
        expandedByDefault
        id="your-roles-section"
        sectionName="your_roles-sections"
        title={I18n.t('side_nav.your_roles.title')}
        renderChildren={() => (
          sortByNameCaseInsensitive(uniqueCircles).map((circle) => (
            <CircleAssignments
              key={circle.id}
              circle={circle}
              assignments={circleAssignments(circle)}
            />
          ))
        )}
      />
    </Fragment>
  )
}

export default (createFragmentContainer(YourRolesSection, {
  organization: graphql`
    fragment YourRolesSection_organization on Organization {
      viewer {
        assignments {
          edges {
            node {
              role {
                circle {
                  id
                  localizedName

                  ...CircleAssignments_circle
                }
              }
  
              ...CircleAssignments_assignments
            }
          }
        }
      }
    }
  `,
}): RelayFragmentContainer<typeof(YourRolesSection)>)
